import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: "https://nodeapp.shrinkcom.com/kwacharides-backend",
  // baseURL: "http://192.168.0.173:6010",
});

export default instance;
